<template>
  <div class="collection-record">
    <pageHeader title="领取记录" />

    <div class="invite-record-table" v-if="collectList.length">
      <div class="table-thead">
        <div class="thead-th">
          <span>时间</span>
          <span class="block-box"></span>
        </div>
        <div class="thead-th">
          <span>好友</span>
          <span class="block-box"></span>
        </div>
        <div class="thead-th">
          <span>类型</span>
          <span class="block-box"></span>
        </div>
        <div class="thead-th">
          <span>优惠券</span>
          <span class="block-box"></span>
        </div>
      </div>
      <div class="table-tbody">
        <div class="tbody-td" v-for="(item, i) in collectList" :key="i">
          <span>{{item.getTime}}</span>
          <span>{{item.phone}}</span>
          <span>{{item.type}}</span>
          <span>满{{item.amount}}减{{item.enableAmount}}</span>
        </div>
      </div>
    </div>

    <div class="empty" v-else>
      <img
        classs="empty-img"
        src="@/assets/images/ic_default_three.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import pageHeader from "@/components/PageHeader";
import { requestMethods } from "@m/api";
import { mapGetters } from "vuex";
export default {
  components: {
    pageHeader,
  },
  computed: {
    ...mapGetters(["uuid"]),
  },
  data() {
    return {
      collectList: [],
      currentPage: 1,
      pageSize: 999
    };
  },
  mounted() {
    this.fetchInviteCouponList()
  },
  methods: {
    /**
     * 获取领取记录
     */
    async fetchInviteCouponList() {
      try {
        const { data } = await requestMethods(
          "/modules/user/user/fetchInviteCouponList.htm",
          "post",
          {
            uuid: this.uuid,
            appType: 'WM',
            currentPage: this.currentPage,
            pageSize: this.pageSize
          }
        );
        this.collectList = data || []
      } catch (err) {
        this.$toast(err.message)
      }
    },
    
  }
};
</script>

<style lang="scss" scoped>
.collection-record {
  background: #f8f8f8;
  min-height: 100vh;
  .invite-record-table {
    background: #fff;
    margin-top: 20px;
    .table-thead {
      display: flex;
      justify-content: space-between;
      height: 80px;
      width: 700px;
      margin: 0 25px;

      .thead-th {
        width: 175px;
        padding: 20px 32px;
        border-bottom: 1px solid #f2f2f2;
        text-align: center;
      }

      span {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 28px;
        color: #333333;
        line-height: 40px;
        display: block;
      }
      .block-box {
        width: 80px;
        height: 12px;
        background: linear-gradient(
          270deg,
          rgba(255, 255, 255, 0) 0%,
          #ffbead 100%
        );
        margin-top: -10px;
        margin-left: 14px;
      }
    }
    .table-tbody {
      padding: 0 25px;
      .tbody-td {
        display: flex;
        height: 80px;
        text-align: center;
        border-bottom: 1px solid #f2f2f2;

        span {
          display: block;
          width: 50%;
          line-height: 80px;
        }
      }
    }
  }
  .empty {
    text-align: center;
    margin-top: 50%;
    empty-img {
      
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/collectionRecord/index.vue